import Button from "components/Buttons/Button/Button";
import Buttons from "components/Buttons/Buttons/Buttons";
import MainCard from "components/layout/MainCard/MainCard";
import Sitemap from "routes/sitemap";
import { useTranslation } from "react-i18next";

import scss from "./PageNotFound.module.scss";

const PageNotFound = () => {
    const { t } = useTranslation();

    return (
        <MainCard>
            <div className="page-container">
                <div className={`p page-content ${scss.container}`}>
                    <h3 className={scss.title}>404</h3>
                    <h4>{t("global-page_not_found-title")}</h4>
                    <p>{t("global-page_not_found-description")}</p>
                    <Buttons align="center">
                        <Button to={Sitemap.home} label={"global-page_not_found-button-homepage"} />
                    </Buttons>
                </div>
            </div>
        </MainCard>
    );
};

export default PageNotFound;
